import { ProductFooter } from '@adtech/ui';
import AdBlockerNotification from '@components/AdBlockerNotification';
import DocumentsTree from '@components/DocumentsTree';
import { RightColumn } from '@components/GridLayout';
import Header from '@components/Header';
import HeaderMobileLogin from '@components/Header/components/HeaderMobileLogin';
import Search from '@components/Search';
import { useAppDispatch, useAppSelector } from '@hooks/useStore';
import { IconAbout } from '@images/svg/about';
import { IconLogin } from '@images/svg/login';
import { IconMainHeader } from '@images/svg/main-header';
import { IconReport } from '@images/svg/report';
import { IconStat } from '@images/svg/stat';
import { IconTd } from '@images/svg/td';
import { IconTech } from '@images/svg/tech';
import { useGetDocumentsQuery, useGetNamespaceQuery, useGetMostPopularDocumentsQuery } from '@redux/api/adminApi';
import { setNamespace } from '@redux/slices/document';
import { setMenuOpen } from '@redux/slices/global';
import { Loader } from '@sberlab/core-components';
import { IRootSlice } from '@typings/rootSlice';
import './Main.less';
import React, { useEffect } from 'react';
import DocumentTitle from 'react-document-title';
import { Link } from 'react-router-dom';

const Main: React.FC = () => {
    const dispatch = useAppDispatch();
    const menuOpen = useAppSelector((state: IRootSlice) => state.globalSlice.menuOpen);
    const documentTree = useAppSelector((state) => state.documentSlice.tree).help || null;

    useEffect(() => {
        dispatch(setNamespace('help'));
    }, []);

    const { data: namespaceData } = useGetNamespaceQuery('help');

    const { isFetching: isDocumentsLoading } = useGetDocumentsQuery(
        { namespaceId: namespaceData?.id, level: 1 },
        { skip: !namespaceData?.id }
    );

    const { data: popularData } = useGetMostPopularDocumentsQuery();

    const handleClickMenuItem = (isClickOnIcon: boolean) => {
        if (!isClickOnIcon) {
            dispatch(setMenuOpen(false));
        }
    };

    const documentTitle = 'Справка';

    return (
        <div className="layout">
            <div className="layout__header">
                <Header hideSearch hideMenu />
            </div>
            <div className="layout__main main__outer">
                <div className="layout__content">
                    <div className={`main__left-column ${menuOpen ? 'open' : ''}`}>
                        <div className="main__left-column__inner">
                            <Loader loading={isDocumentsLoading }>
                                <DocumentsTree items={documentTree} onClickItem={handleClickMenuItem} hideSearch />
                            </Loader>
                        </div>
                        <div className="main__left-column__overlay" onClick={() => dispatch(setMenuOpen(false))} />
                    </div>
                    <div className='main'>
                        <DocumentTitle title={documentTitle} />
                        <div className='main__container'>
                            <div className='main__header'>
                                <div className='main__logo'><IconMainHeader /></div>
                                <div className='main__title'>Чем вам помочь?</div>
                                <div className='main__input'><Search /></div>
                            </div>
                            <div className='main__cards'>
                                <Link to='/help/about' className='main__cards__item'>
                                    <IconAbout />
                                    <div className='main__cards__title'>Агентский рекламный кабинет</div>
                                    <div className='main__cards__descr'>Узнай подробнее о платформе и ее возможностях</div>
                                </Link>
                                <Link to='/help/login' className='main__cards__item'>
                                    <IconLogin />
                                    <div className='main__cards__title'>Создание аккаунта</div>
                                    <div className='main__cards__descr'>Узнай подробнее о платформе и ее возможностях</div>
                                </Link>
                                <Link to='/help/otchety-po-reklame' className='main__cards__item'>
                                    <IconReport />
                                    <div className='main__cards__title'>Отчёты  по рекламе</div>
                                    <div className='main__cards__descr'>Узнай подробнее о платформе и ее возможностях</div>
                                </Link>
                                <Link to='/help/stat' className='main__cards__item'>
                                    <IconStat />
                                    <div className='main__cards__title'>Статистика от SberAds</div>
                                    <div className='main__cards__descr'>Узнай подробнее о платформе и ее возможностях</div>
                                </Link>
                                <Link to='/help/td' className='main__cards__item'>
                                    <IconTd />
                                    <div className='main__cards__title'>Рекламный кабинет</div>
                                    <div className='main__cards__descr'>Узнай подробнее о платформе и ее возможностях</div>
                                </Link>
                                <Link to='/help/tekhnicheskie-trebovaniya-k-reklamnym-materialam' className='main__cards__item'>
                                    <IconTech />
                                    <div className='main__cards__title'>Технические требования</div>
                                    <div className='main__cards__descr'>Узнай подробнее о платформе и ее возможностях</div>
                                </Link>
                            </div>
                            {popularData && popularData.length > 0 && <div className='main__popular'>
                                <div className='main__popular__title'>Популярные запросы</div>
                                <div className='main__popular__menu'>
                                    {popularData?.map((item) => (
                                        <Link key={item.document_id} to={`/help/${item.title_for_url}`} className='main__popular__item'>
                                            {item.title} →
                                        </Link>
                                    ))}
                                </div>
                            </div>}
                        </div>
                    </div>
                    <RightColumn className="main__right">
                        <HeaderMobileLogin />
                    </RightColumn>
                </div>
                <ProductFooter />
            </div>
            <AdBlockerNotification />
        </div>
    )
};

export default Main;
